document.addEventListener('DOMContentLoaded', function () {
    const popupTriggers = document.querySelectorAll('.wiacc-show-popup');

    popupTriggers.forEach(trigger => {
        trigger.addEventListener('click', function () {
            const targetValue = this.getAttribute('data-target');
            const popupTarget = 'popup-' + targetValue;
            const delay = parseInt(this.getAttribute('data-timer')) || 0;

            setTimeout(() => {
                handleFocusTrap(trigger, popupTarget);
                handleEscapeClose();
            }, delay);
        });
    });
});